module.exports = __webpack_public_path__ + "img/2_3.18911392.jpg";